export default __webpack_public_path__ + "locales/bg/ChangeUserStatusDialog.json?hash=1c13f3c78d1c8482b889201acd6e4057";